import Feature from "./components/feature/Feature";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Product from "./components/product/Product";
import Compare from "./components/section/Compare";
import Ingredient from "./components/section/Ingredient";
import Selfcare from "./components/section/Selfcare";
import Testimonial from "./components/section/Testimonial";
import Spotlight from "./components/section/Spotlight";
import Vipexp from "./components/section/Vipexp";
import FinalCTA from "./components/section/FinalCTA";
import Faq from "./components/section/Faq";
import ReviewCarousel from "./components/section/ReviewCarousel";
import WhyChoose from "./components/section/WhyChoose";


function App() {
  return (
    <div className="diddy-app">
      <Header/>
      <Product />
      <Feature />
      <Testimonial />
      <Selfcare/>
      <Vipexp/>
      <Spotlight/>
      <Ingredient/>
      <Compare />
      <WhyChoose />
      <ReviewCarousel/>
      <Faq />
      <FinalCTA />
      <Footer/>
    </div>
  );
}

export default App;
